// SPDX-FileCopyrightText: 2022 Genome Research Ltd.
//
// SPDX-License-Identifier: MIT
import { env } from '../../variables/config';
var serializeParam = function (k, v) {
    var sK = encodeURIComponent(k);
    var sV;
    if (typeof (v) == "string") {
        sV = encodeURIComponent(v);
    }
    else {
        sV = encodeURIComponent(JSON.stringify(v));
    }
    return "".concat(sK, "=").concat(sV);
};
var serializeParams = function (params) { return Object.entries(params).filter(function (_a) {
    var _ = _a[0], v = _a[1];
    return v !== undefined;
} // eslint-disable-line
).map(function (_a) {
    var k = _a[0], v = _a[1];
    return serializeParam(k, v);
}).join('&'); };
export var CONFIG = {
    baseURL: env.API_PATH,
    headers: {
        'Content-Type': 'application/json',
    },
    paramsSerializer: serializeParams,
};
